import WordsTrivia from "../../modules/games/words-trivia";
import clsx from "clsx";
import { Trivia } from "../games/Trivia";
import { useTriviaQuestions } from "../../api/trivia/useTriviaQuestions";
import { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import { TransparentLoader } from "../../modules/world/rmc/modals/transparentLoader";
import { ArenaGameOverModal } from "../../modules/world/rmc/modals/ArenaGameOverModal";
import { useServerSyncTimer } from "../../hooks/useServerSyncTimer";

function TriviaInjections({
  type,
  isReset,
  resetIsReset,
  getScore,
  start,
  getStatus,
  getTotal,
  handleResume,
  gameWon,
  id,
  color,
}) {
  const navigate = useNavigate();
  const [currentQuestion, setCurrentQuestion] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null);
  const hasFetched = useRef(false);

  const [score] = useState(0);
  const {
    handleshowTriviaQuestions,
    questions,
    loading,
    handleSubmitAnswer,
    submitting,
    selectedAnswers,
    setSelectedAnswers,
    showGameOver,
    results,
  } = useTriviaQuestions();

  // Initialize server-sync timer with callback for when time runs out
  const { timeLeft, pauseTimer, setDuration, startTimer } = useServerSyncTimer(
    60, // Default 60 seconds
    () => {
      // Auto-submit when time runs out
      if (type === "trivia_hub") {
        handleSubmitAnswer(id, true);
      }
    },
    false, // Don't auto-start, wait for questions to load
  );

  useEffect(() => {
    if (type === "trivia_hub" && id && !hasFetched.current) {
      hasFetched.current = true;
      handleshowTriviaQuestions(id).then((duration) => {
        if (duration) {
          setDuration(duration);
          startTimer(duration);
        }
      });
    } else if (type === "trivia_hub" && !id && !hasFetched.current) {
      hasFetched.current = true;
      handleshowTriviaQuestions(id).then((duration) => {
        if (duration) {
          setDuration(duration);
          startTimer(duration);
        }
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [id]);

  useEffect(() => {
    if (selectedAnswers.length > 0) {
      setSelectedAnswer(selectedAnswers[currentQuestion]);
    }
  }, [currentQuestion, selectedAnswers]);

  // REFERSH LOGIC
  useEffect(() => {
    const gameOverWasShowing = sessionStorage.getItem("gameOverActive");

    // If either was true during refresh, kick user out
    if (gameOverWasShowing === "true") {
      sessionStorage.removeItem("gameActive");
      sessionStorage.removeItem("gameOverActive");
      navigate(-1);
      return;
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (questions.length > 0 && !showGameOver) {
      sessionStorage.setItem("gameActive", "true");
    } else {
      sessionStorage.removeItem("gameActive");
    }
  }, [questions.length, showGameOver]);

  // Track game over state
  useEffect(() => {
    if (showGameOver) {
      sessionStorage.setItem("gameOverActive", "true");
    } else {
      sessionStorage.removeItem("gameOverActive");
    }
  }, [showGameOver]);

  const handleSubmitWithPause = () => {
    pauseTimer(); // Pause the timer using new hook
    sessionStorage.removeItem("gameActive");
    sessionStorage.removeItem("gameOverActive");

    handleSubmitAnswer(id, true);
  };

  const handleAnswerSelect = (selectedChoice) => {
    setSelectedAnswers((prev) => {
      const newAnswers = [...prev];
      newAnswers[currentQuestion] = {
        answer_id: selectedChoice?.id,
        question_id: selectedChoice?.question_id,
      };
      return newAnswers;
    });
  };

  const handleBack = () => {
    if (currentQuestion > 0) {
      setCurrentQuestion((prev) => prev - 1);
    }
  };
  const handleNext = () => {
    if (currentQuestion < questions.length - 1) {
      setCurrentQuestion((prev) => prev + 1);
    }
  };

  const currentQ = questions[currentQuestion];
  const isLastQuestion = currentQuestion === questions.length - 1;

  const loadingLength = new Array(12).fill("_");

  return (
    <div
      className={clsx(
        type === "spin_the_wheels"
          ? ""
          : "max-h-[80vh] overflow-y-auto hidden-scrollbar",
        "container min-h-[70vh] relative pt-[4%] 880:pt-[5%] pb-12 overflow-y-auto",
      )}
    >
      {type === "trivia_hub" && (
        <>
          {submitting && <TransparentLoader color={color ?? "#2741d6"} />}
          {showGameOver && (
            <ArenaGameOverModal results={results} isArena={true} color={color} />
          )}
          <Trivia
            loading={loading}
            isArena={true}
            loadingLength={loadingLength}
            score={score}
            timeLeft={timeLeft}
            currentQuestion={currentQuestion}
            questions={questions}
            currentQ={currentQ}
            handleAnswerSelect={handleAnswerSelect}
            selectedAnswer={selectedAnswer}
            selectedAnswers={selectedAnswers}
            handleBack={handleBack}
            handleSubmitWithPause={handleSubmitWithPause}
            isLastQuestion={isLastQuestion}
            handleNext={handleNext}
            color={color}
          />
        </>
      )}
      {type === "word_trivia" && <WordsTrivia id={id} />}
    </div>
  );
}

export default TriviaInjections;
